import styled from "styled-components";
interface JackpotBetWinHighlightAmountDefaultBoxProps {
    fontSize?: string;
}
export const JackpotBetWinHighlightAmountDefaultBox = styled.div<JackpotBetWinHighlightAmountDefaultBoxProps>`
    display: flex;
    font-size: ${({fontSize}) => fontSize || "4.8rem"};
    font-weight: 700;
    color: #FFED40;
    background: linear-gradient(180deg, #FFED40 0%, #FCD203 100%);         
    text-align: center;
    /* text-shadow: 0 2px #665501 ; */
    filter: drop-shadow(0px 3px #665501);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: ${({fontSize}) => fontSize || "4.8rem"};
    justify-content: center;
`

